module.exports = __webpack_public_path__ + "static/media/pexels-belle-co-342008.81317d7d.png";